import { render, staticRenderFns } from "./AddLessonTypeDialog.vue?vue&type=template&id=0e6fe471&scoped=true"
import script from "@/views/LessonTypes/AddLessonTypeDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/LessonTypes/AddLessonTypeDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/LessonTypes/add-lesson-type-dialog.scss?vue&type=style&index=0&id=0e6fe471&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6fe471",
  null
  
)

export default component.exports